import { useEffect, useRef, createRef, useState, useCallback } from 'react';
import * as L from 'leaflet';
import RasterCoords from 'leaflet-rastercoords';
import useFadeMapLayer from '/src/hooks/useFadeMapLayer';
import ModalError from '../Modal/ModalError';
import ModalLoading from '../Modal/ModalLoading';
import { useGetMapMetadataQuery, useGetMapUriQuery } from '/src/redux/mapsApi';

export default function MapTileLayerGeo({map, mapName, attribution, show, onMetadata, zIndex}){

    // const map = useRef(null);
    const mapLayer = useRef(null);
    const [error, setError] = useState(null);
    const { data: mapBaseUri, error: mapBaseUriError, isLoading: mapBaseUriIsLoading } = useGetMapUriQuery(mapName, {skip: !mapName});
    const { data: metadata, error: metadataError, isLoading: metadataIsLoading } = useGetMapMetadataQuery(mapBaseUri, {skip: !mapBaseUri});
    const _loading = mapBaseUriIsLoading || metadataIsLoading;

    useEffect(()=>{
        if(mapBaseUriError) setError(mapBaseUriError.data);
        else if(metadataError) setError(metadataError.data);
    }, [mapBaseUriError, metadataError])

    // init map
    useEffect(()=>{
        if(map && mapBaseUri && metadata){
            // the tile layer containing the image generated with "gdal2tiles"
            mapLayer.current = L.tileLayer(`${mapBaseUri}/tiles/{z}/{x}/{y}.png`, {
                tms: true,
                bounds: metadata.bounds,
                minZoom: metadata.minZoom,
                maxZoom: metadata.maxZoom,
                noWrap: true,
                attribution: attribution || false,
                opacity: show? 1 : 0,
                zIndex: parseInt(zIndex) || 0,
            }).addTo(map);

            if(onMetadata) onMetadata(metadata);
        }
        return ()=>{
            // Clean up tile layer
            if(map && mapLayer.current){ 
                map.removeLayer(mapLayer.current);
            }
        }
    },[map, metadata, mapBaseUri]);

    useFadeMapLayer(mapLayer, show);

    useEffect(()=>{
        if(mapLayer.current){
            const newIndex = parseInt(zIndex) || 0;
            mapLayer.current.setZIndex(newIndex);
        }
    },[mapLayer, zIndex]);

    return (
        <div className='w-0 h-0 absolute top-0 left-0'>
            {error && <ModalError message={`Failed to load map tile data for layer "${mapName}".`} description={error.message} callback={()=>setError(null)} />}
            {_loading && <ModalLoading />}
        </div>
    )
}